var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14621 16.2213C7.99307 16.2222 7.84126 16.1928 7.69949 16.1349C7.55772 16.077 7.42877 15.9917 7.32004 15.8838L0.33837 8.90216C0.121646 8.68415 0 8.38923 0 8.08182C0 7.77441 0.121646 7.47949 0.33837 7.26147L7.32004 0.279799C7.54264 0.0891684 7.82898 -0.0104439 8.12183 0.000867801C8.41469 0.0121795 8.69249 0.133581 8.89972 0.340814C9.10695 0.548047 9.22835 0.825847 9.23967 1.1187C9.25098 1.41155 9.15136 1.69789 8.96073 1.92049L2.80523 8.076L8.96073 14.2315C9.12413 14.3936 9.2358 14.6004 9.28163 14.826C9.32746 15.0515 9.30539 15.2855 9.2182 15.4985C9.13102 15.7115 8.98264 15.8938 8.79183 16.0225C8.60101 16.1511 8.37634 16.2203 8.14621 16.2213Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.f1dbfc0118e1219b034fe955a621e148.svg";
export { ForwardRef as ReactComponent };